import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImageStackPlus32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconImageStackPlus32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19.257 13a5.5 5.5 0 0 0 2.732 1.79q.01.104.011.21v8a2 2 0 0 1-2 2h-2.586l-7.707-7.707-.633-.633-.699.56L5 19.92V15a2 2 0 0 1 2-2zM24 14.978V22a2 2 0 0 0 2-2v-5.6a5.5 5.5 0 0 1-2 .578m4-2.315A5.5 5.5 0 1 0 18.6 7H10a4 4 0 0 0-4 4v.126c-1.725.444-3 2.01-3 3.874v8a4 4 0 0 0 4 4h13a4 4 0 0 0 3.874-3H24a4 4 0 0 0 4-4zM18.022 9H10a2 2 0 0 0-2 2h10.207a5.5 5.5 0 0 1-.185-2M23.5 6.5a.75.75 0 0 0-.75.75v1.5h-1.5a.75.75 0 0 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 0 0 0-1.5h-1.5v-1.5a.75.75 0 0 0-.75-.75M5 22.48V23a2 2 0 0 0 2 2h7.586l-5.66-5.66zM17 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconImageStackPlus32);
